<template>
  <div class="page-container">
    <sub-header>
      <template slot="title">{{$route.meta.title}}
      </template>
      <template slot="btn">
        <el-button @click="openDialog()"
                   style="float:right"
                   size="medium"
                   v-has="'Edit Member'"
                   type="primary">{{$t('members.AddMembers')}}</el-button>
      </template>
      <template slot="search">
        <el-row :gutter="20">
          <el-col :lg="8"
                  :md="6">
            <el-input :placeholder="$t('members.SearchMemberNameOrEmail')"
                      size="mini"
                      @change="getProjectMember()"
                      v-model="condition.NameOrEmail"></el-input>
          </el-col>
        </el-row>
      </template>
    </sub-header>
    <div class="main">
      <div class="left">
        <myScroll style="width:100%;height:100%">
          <el-table :data="list"
                    class="table"
                    v-loading="loading"
                    style="position:absolute"
                    :highlight-current-row="false"
                    @row-click="changeDetail"
                    :row-class-name="tableRowClassName"
                    :show-header="false">
            <el-table-column width="6">
            </el-table-column>
            <el-table-column width="45">
              <template slot-scope="scope">
                <div class="user-logo">
                  <img :src="scope.row.AvatarUrl"
                       alt="">
                </div>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <div class="text">
                  {{scope.row.FullName}} -- {{$t('api.'+scope.row.RoleName)}}
                  <i v-if="scope.row.UserId === userInfo.UserId">({{$t('api.me')}})</i>
                </div>
                <div class="text">
                  {{scope.row.LoginAccount}}
                </div>
              </template>
            </el-table-column>
            <el-table-column width="50">
              <template slot-scope="scope">
                <el-button circle
                           size="mini"
                           style="margin-right: 10px"
                           v-has="'Edit Member'"
                           @click="deleteProjectMember(scope.row.UserId)"
                           v-if="scope.row.UserId !== userInfo.UserId &&  scope.row.UserId !== CreatorId"
                           icon="el-icon-delete"
                           type="danger"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </myScroll>
      </div>
      <div class="right">
        <div class="member-contian">
          <div class="member-box">
            <div>
              <div class="user-logo">
                <img :src="detail.AvatarUrl"
                     alt="">
              </div>
            </div>
            <h3>{{detail.FullName}}</h3>
            <div class="text">
              <span>{{$t('members.Email')}}</span>
              <span>{{detail.LoginAccount}}</span>
            </div>
            <div class="text">
              <span>{{$t('members.Role')}}</span>
              <span>{{detail.RoleName}}</span>
            </div>
            <div class="text">
              <span>{{$t('corpDialog.Phone')}}</span>
              <span>{{detail.Phone}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddMemberDialog :showDialog="addMemberDialog.showDialog"
                     @closeDialog="closeDialog"
                     :outsideList="addMemberDialog.list"></AddMemberDialog>
  </div>
</template>

<script>
import { getProjectMember, deleteProjectMember } from '@/api/config'
import AddMemberDialog from '@components/members/addMemberDialog'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      addMemberDialog: {
        showDialog: false,
        list: []
      },
      detail: {},
      list: [],
      total: 0,
      condition: {
        PageIndex: 1,
        PageSize: 1000,
        NameOrEmail: null
      },
      selectedId: null
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'userInfo', 'CreatorId'])
  },
  created () {
    this.getProjectMember()
  },
  mounted () {
  },
  watch: {

  },
  methods: {
    closeDialog () {
      this.addMemberDialog.list = []
      this.getProjectMember()
      this.addMemberDialog.showDialog = false
    },
    openDialog () {
      this.addMemberDialog.list = this.list
      this.addMemberDialog.showDialog = true
    },
    handleCurrentChange (val) {
      this.condition.PageIndex = val
      this.getProjectMember()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (this.selectedId === row.UserId) {
        return 'success-row'
      }
    },
    changeDetail (row) {
      this.detail = row
      this.selectedId = row.UserId
    },
    getProjectMember () {
      this.loading = true
      this.condition.JobsiteId = this.jobsiteID
      getProjectMember(this.condition).then(res => {
        this.list = res.Data
        this.total = res.TotalCount
        this.list.forEach(ele => {
          ele.AvatarUrl = this.$config.baseURL + '/api/Attachments/' + ele.DocFileId + '?isAvatar=true'
          if (ele.UserId === this.userInfo.UserId) {
            this.detail = ele
            this.selectedId = ele.UserId
          }
        })
        this.loading = false
      })
    },
    deleteProjectMember (id) {
      this.$confirm(this.$t('members.AreYouSureYouWantToDeleteThisMember'), this.$t('members.TIPS'), {
        confirmButtonText: this.$t('members.Yes'),
        cancelButtonText: this.$t('members.No'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        let params = {
          JobsiteId: this.jobsiteID,
          MemberUserIds: []
        }
        params.MemberUserIds.push(id)
        let arr = []
        arr.push(params)
        deleteProjectMember(arr).then(res => {
          this.getProjectMember()
        })
      }).catch(() => {
      })
    }
  },
  components: {
    AddMemberDialog
  }
}
</script>

<style scoped lang="scss">
.main {
  flex-direction: row !important;
  padding: 0 8px 10px;
  .left {
    height: 100%;
    width: 450px;
    border-radius: 5px;
    .table {
      border-radius: 5px;
      .text {
        overflow: hidden;
        height: 25px;
        width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
        float: left;
      }
      .el-button {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
      }
    }
    .user-logo {
      width: 32px;
      height: 32px;
      overflow: hidden;
      position: absolute;
      border-radius: 50%;
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .right {
    flex: 1;
    margin-left: 10px;
    box-sizing: border-box;
    position: relative;
    height: 100%;
    overflow: hidden;
    .member-contian {
      width: 100%;
      height: 100%;
      background-color: #fff;
      border-radius: 5px;
    }
    .member-box {
      position: absolute;
      width: 100%;
      top: 50%;
      transform: translate(0, -50%);
      overflow: hidden;
      div:first-child {
        margin: 0 auto;
        .user-logo {
          height: 100px;
          width: 100px;
          overflow: hidden;
          position: relative;
          border-radius: 5px;
          img {
            height: 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
      h3 {
        color: #606266;
        text-align: center;
        font-size: 28px;
      }
      .text {
        width: 60%;
        margin: 0px auto 20px;
        text-align: center;
        border-bottom: 1px solid #e4e7ed;
        color: #606266;
        height: 40px;
        line-height: 40px;
        span:first-child {
          float: left;
        }
        span:last-child {
          float: right;
        }
      }
    }
  }
}
/deep/.el-table .success-row {
  background: #f0f9eb;
}
</style>
